import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'grid-double-button-render',
  template:
    '<div class=\'itemcode\'>' + 
      '<a *ngIf="this.params.leftButton && this.params.leftButton.text != null" class="btn_secondary" (click)="onLeftButtonClick()">{{this.params.leftButton.text}}</a>' +
      '<a *ngIf="this.params.rightButton && this.params.rightButton.text" class="btn_secondary" (click)="onRightButtonClick()">{{this.params.rightButton.text}}</a>' +
    '</div>',
  styleUrls: ['./grid-double-button-renderer.component.css']
})
export class GridDoubleButtonRendererComponent implements ICellRendererAngularComp {
  public params: any;

  constructor() {}
  agInit(params: any): void {
    this.params = params;
  }

  onLeftButtonClick($event): void {
    if (this.params.leftButton.onClick instanceof Function) this.params.leftButton.onClick(this.params.node);
  }

  onRightButtonClick($event): void {
    if (this.params.rightButton.onClick instanceof Function) this.params.rightButton.onClick(this.params.node);
  }

  refresh(): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/render/grid-double-button-renderer.component.ts